import React, { useState } from 'react';
import { validateDebounce, VALIDATION_RULES } from '@constants';
import { Button, Input, Typography } from '@ui';
import { Form } from 'antd';
import { StyledButtonsWrapper, StyledContent, StyledDescription } from './styled';

const ExportViaEmailModal = ({ close, userEmail, onSubmit }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            await onSubmit(values.email);
            close();
        } catch (error) {
            setLoading(false);
        }
    };

    return (
        <Form form={form} onFinish={handleSubmit} initialValues={{ email: userEmail }}>
            <StyledContent>
                <StyledDescription>
                    <Typography.Text>
                        This file is too large for a direct download. We can generate the report in the background and
                        email the link to you once it is ready.
                    </Typography.Text>
                </StyledDescription>

                <Form.Item
                    name='email'
                    rules={[...VALIDATION_RULES.REQUIRED, ...VALIDATION_RULES.EMAIL]}
                    validateDebounce={validateDebounce}
                    normalize={(value) => value?.trim()}
                >
                    <Input
                        label='Send to'
                        type='email'
                        placeholder='Enter your email'
                        data-e2e='export-via-email_email-input'
                    />
                </Form.Item>

                <StyledButtonsWrapper>
                    <Button
                        style={{ width: 160 }}
                        onClick={close}
                        disabled={loading}
                        data-e2e='export-via-email_cancel-btn'
                    >
                        Cancel
                    </Button>
                    <Button
                        style={{ width: 160 }}
                        type='primary'
                        htmlType='submit'
                        loading={loading}
                        data-e2e='export-via-email_send-btn'
                    >
                        Send Export
                    </Button>
                </StyledButtonsWrapper>
            </StyledContent>
        </Form>
    );
};

export default ExportViaEmailModal;
